import { currencyRepository } from '@webapp/core/data-access/repositories/CurrencyRepository'
import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'

const base = ['selects', 'currencies']

export const currencyQueryConfig = {
  listActive: () => ({
    queryKey: buildQueryKey(base),
    queryFn: () => currencyRepository.getAllActive(),
    cacheTime: Infinity,
  }),
}
